// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H11V9H2V2ZM13 2H22V13H13V2ZM2 11H11V22H2V11ZM13 15H22V22H13V15Z"}}]};

const Dashboard1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dashboard-1-filled',
    ref,
    icon: element,
  },
));

Dashboard1FilledIcon.displayName = 'Dashboard1FilledIcon';

export default Dashboard1FilledIcon;
